import { render, staticRenderFns } from "./CommentOnHoldModal.vue?vue&type=template&id=defcd040&scoped=true&"
import script from "./CommentOnHoldModal.vue?vue&type=script&lang=js&"
export * from "./CommentOnHoldModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentOnHoldModal.vue?vue&type=style&index=0&id=defcd040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defcd040",
  null
  
)

export default component.exports